module.exports = __webpack_public_path__ + "img/jkopay.e08b9d34.svg";